
import Banner from "../components/home/Banner";
import Programs from "../components/home/Programs";
import Stats from "../components/home/Stats";

function Home() {
  return (
    <div className="main-content">
      <Banner />
      <Stats />
      <Programs />
    </div>
  );
}

export default Home;
